import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import CustomerApis from '../apis/customer';
import ProductApis from '../apis/product';
import EstimateApis from '../apis/estimate';
import UserApis from '../apis/user';
import OrderApis from '../apis/order';

const ApiContext = createContext({
  customerApis: null,
  productApis: null,
  estimateApis: null,
  userApis: null,
  orderApis: null,
});

export const ApiProvider = ({ children }) => {
  const { user } = useAuth();
  const [customerApis, setCustomerApis] = useState(null);
  const [productApis, setProductApis] = useState(null);
  const [estimateApis, setEstimateApis] = useState(null);
  const [userApis, setUserApis] = useState(null);
  const [orderApis, setOrderApis] = useState(null);

  useEffect(() => {
    console.log('ApiProvider user:', user);
    
    if (!user) {
      setCustomerApis(null);
      setProductApis(null);
      setEstimateApis(null);
      setUserApis(null);
      setOrderApis(null);
      return;
    }

    // Initialize API instances when user is available
    setCustomerApis(new CustomerApis(user.store_id, user.email));
    setProductApis(new ProductApis(user.store_id));
    setEstimateApis(new EstimateApis(user.store_id, user.id, user.email));
    setUserApis(new UserApis(user.id, user.store_id.toString(), user.email));
    setOrderApis(new OrderApis(user.store_id, user.id, user.email));
  }, [user]);

  const value = {
    customerApis,
    productApis,
    estimateApis,
    userApis,
    orderApis,
  };

  return (
    <ApiContext.Provider value={value}>
      {children}
    </ApiContext.Provider>
  );
};

export const useApis = () => {
  const context = useContext(ApiContext);
  if (!context) {
    throw new Error('useApis must be used within an ApiProvider');
  }
  return context;
}; 